import { LabShell } from "./components/LabShell";

/**
 * React root for Adam. LabShell starts labRuntime after TrackerGrid mounts.
 * LabBody is frozen so toolbar/shell class updates do not remount the grid.
 */
export function AudioLabApp() {
  return <LabShell />;
}
